import React from 'react';

const PersonalLink = (props) => {
    const { key, personalLinkDescription: description, personalLinkTitle: title, urlKey: link } = props.personalLink;

    return (
        <div key={key} style={{
            marginBottom: 10,
        }}>
            <a href={link} target="_blank" rel="noreferrer" title={title}
                style={{
                    display: 'block',
                }}>
                {title}
            </a>
            <p style={{
                margin: 0,
            }}><small>{description}</small></p>
        </div>
    );
};

export default PersonalLink;